import { app_route_ids } from "constants/urlPaths";

export const PUBLIC_ROUTES = [
  "login",
  "signup",
  "optout",
  "register",
  app_route_ids.ONBOARDING_THANKYOU_PAGE,
];
